/**
 * Route for `postback-domain`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PostbackDomainPage } from "../features/postback-domain/PostbackDomainPage";

export const postbackDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/postback-domain",
	component: PostbackDomainPage,
});

export default postbackDomainRoute;
